import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';

// services
import { AuthHttpInterceptor } from '../auth/auth.http.interceptor';
import { ScheduledService } from './scheduled.service';

@NgModule({
  imports: [HttpClientModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    },
  ],
})
export class ScheduledServiceModule {
  static forRoot(): ModuleWithProviders<ScheduledServiceModule> {
    return {
      ngModule: ScheduledServiceModule,
      providers: [ScheduledService],
    };
  }
}
